<template>
  <div class="productListing">
    <div class="productListing__tabs">
      <div class="productListing__tabs__item productListing__tabs__item--view is-active" @click="toggleTab">
        <div class="productListing__tabs__content">
          <icon-arrow></icon-arrow>
          <span>Product List</span>
        </div>
      </div>
      <div class="productListing__tabs__item productListing__tabs__item--carousel" @click="toggleTab">
        <div class="productListing__tabs__content">
          <icon-file></icon-file>
          <span>Project Inspiration</span>
        </div>
      </div>
      <div class="productListing__tabs__item productListing__tabs__item--grid" @click="toggleTab">
        <div class="productListing__tabs__content">
          <icon-grid></icon-grid>
          <span>Show Grids</span>
        </div>
      </div>
    </div>
    <div class="productListing__view">
      <div class="productListing__header">
        <h2>Product List</h2>
        <div class="productListing__help">
          <icon-help :hasCircle="true"></icon-help>
        </div>
      </div>
      <div class="productListing__content">
        <div v-for="(group, idx) in listing" class="productListing__group">
          <product-group :data="group"
                         :index="idx"
                         @count-total="countTotalChildren"></product-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductGroup from './ProductListingGroup';
  import Arrow from './../icons/Arrow';
  import File from './../icons/File';
  import Grid from './../icons/Grid';
  import Help from './../icons/Help';

  export default{
    props: ['data'],
    data(){
      return {
        listing: this.data,
        activeItems: 0,
        carousel: {}
      }
    },
    methods: {
      toggleTab(evt){
        var vm = this;
        var tabs = document.querySelectorAll('.productListing__tabs__item');
        tabs.forEach(function(thisTab){
          vm.removeClass(thisTab, 'is-active');
        });
        var target = evt.target;
        while(!vm.hasClass(target, 'productListing__tabs__item')){
          target = target.parentNode;
        }
        vm.addClass(target, 'is-active');
        if(vm.hasClass(target, 'productListing__tabs__item--carousel')){
          vm.openCarousel();
        }
        vm.checkActiveTab();
      },
      openCarousel(){
//        console.log(this.$parent);
        this.$emit('open-carousel');
      },
      checkActiveTab(){
        var vm = this;
        var mainContainer = document.querySelector('.productListing');
        var tabs = document.querySelectorAll('.productListing__tabs__item');
        var idx;
        tabs.forEach(function(currentTab, i){
          if(vm.hasClass(currentTab, 'is-active')){
            idx = i;
          }
        });
        if(idx > 0){
          vm.addClass(mainContainer, 'is-hidden');
        }
        else{
          vm.removeClass(mainContainer, 'is-hidden');
        }
      },
      countTotalChildren(value){
//        console.log(value);
      }
    },
    components: {
      'product-group': ProductGroup,
      'icon-arrow': Arrow,
      'icon-file': File,
      'icon-grid': Grid,
      'icon-help': Help
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/interactive/ProductListing.vue